import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { getSafe } from 'helpers';

/**
 * Fires an event when a click occurs outside of the
 * container for this directive
 */
@Directive({
  selector: '[appOutsideClick]'
})
export class OutsideClickDirective {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input() outsideClickIgnoreEls: Element[];

  @Output() outsideClicked = new EventEmitter<any>();

  constructor(
    private el: ElementRef) {
  }

  @HostListener('keyup', ['$event'])
  escapeKeyPressed(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.outsideClicked.emit(event);
    }
  }

  // Handles clicks outside of the select
  // and close it if it is open
  @HostListener('document:click', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  handleOutsideClick(event) {
    const ignoreElements = this.getIngoreElements();
    if (!this.el.nativeElement.contains(event.target)) {

      // TODO: DO this is more angular way.
      // Problem I am solving here, is that Angular Material
      // inserts its select field overlays outside of the <app-root>
      // so if there is a select dropdown inside of the parent when
      // an option is clicked it will appear to be an outside click
      // even though it should not be treated as an outside click
      const isInAppScope = getSafe(() => document.getElementsByTagName('app-root')[0].contains(event.target), true);

      // Case when the target is also outside of the app root, the child element
      // will actually be in the parent...
      const targetIsNotInAppScope = !document.getElementsByTagName('app-root')[0].contains(this.el.nativeElement);

      // TODO: Multiple overlays...
      if (!isInAppScope && targetIsNotInAppScope) {
        // return;
      }

      if (targetIsNotInAppScope && ignoreElements.find(els => els.contains(event.target)) === undefined) {
        this.outsideClicked.emit(event);
        return;
      }

      if (isInAppScope && ignoreElements.find(els => els.contains(event.target)) === undefined) {
        this.outsideClicked.emit(event);
      }
    }
  }

  private getIngoreElements(): Element[] {
    const explicitElements = this.outsideClickIgnoreEls || [];

    return [...explicitElements];
  }
}
